import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import PageContext from '../../../config/page-settings.js';

import DenariiTransactionsList from './DenariiTransactionsList';

const DenariiTransactions = (props) => {
  const pageContext = useContext(PageContext);

  useEffect(() => {
    pageContext.handleSetPageSidebar(true);
    pageContext.handleSetPageHeader(true);
    pageContext.handleSetPageContentFullWidth(false);
  }, []);

  return (
    <div>
      <h1 className="page-header">Denarii Transactions</h1>
      <DenariiTransactionsList />
    </div>
  );
};

export default withRouter(DenariiTransactions);
